// WellnessEggCounter.js - 웰니스 화면 전용 에그 카운터
import React from 'react';
import egg from '../../assets/v4_img/orange_egg_big.png';
import { useGlobalPoints } from '../../contexts/GlobalPointsContext';
import { formatPoints } from '../../utils/numberFormat';

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    color: '#2D3748',
    padding: '10px 16px',
    borderRadius: '20px',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.6)',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    marginTop: '15px',
    cursor: 'pointer',
    pointerEvents: 'auto',
    userSelect: 'none'
  },
  eggImage: {
    width: '24px',
    height: '24px',
    objectFit: 'contain',
    imageRendering: 'crisp-edges',
    filter: 'drop-shadow(0 1px 3px rgba(255, 107, 53, 0.3))',
    pointerEvents: 'none'
  },
  pointsText: {
    marginLeft: '8px',
    fontSize: '18px',
    fontWeight: '700',
    fontFamily: 'Pretendard',
    color: '#FF6B35',
    pointerEvents: 'none'
  }
};

function WellnessEggCounter({ backgroundColor }) {
  const { points } = useGlobalPoints();

  return (
    <>
      <style>{`
        @media screen and (min-width: 360px) and (max-width: 480px) {
          .wellness-egg-counter-text {
            font-size: clamp(16px, 4vw, 20px) !important;
          }
        }
        @media screen and (min-width: 481px) and (max-width: 768px) {
          .wellness-egg-counter-text {
            font-size: clamp(17px, 3.5vw, 20px) !important;
          }
        }
      `}</style>
      <div style={styles.container}>
        <img src={egg} alt="egg" style={styles.eggImage} />
        <span className="wellness-egg-counter-text" style={styles.pointsText}>
          {formatPoints(points)}
        </span>
      </div>
    </>
  );
}

export default WellnessEggCounter;
